document.querySelectorAll('.star-input input').forEach(input => {
    input.addEventListener('click', () => {
        document.querySelectorAll('.star-input input').forEach(element => {
            delete element.parentElement.dataset.active
        })
        input.parentElement.dataset.active = 'true';
    })
})
